import { useState } from 'react';

function Square({ value, onSquareClick }) {
  // const  [value, setValue] = useState(null);
  
  return (
    <button
      className="square"
      onClick={onSquareClick}
      >
      { value }
    </button>
  ) 
}
export default function Game() {
  const [currentMove, setCurrentMove] = useState(0);
  const xIsNext = currentMove % 2 === 0;
  const [history, setHistory] = useState([Array(9).fill(null)]);
  const currentSquares = history[currentMove];

  function handlePlay(nextSquares) {
    const nextHistory = [...history.slice(0, currentMove + 1), nextSquares]
    setHistory(nextHistory)
    setCurrentMove(nextHistory.length - 1)
    
  }

  function jumpTo(nextMove) {
    setCurrentMove(nextMove);
  }

  const moves = history.map((squares, move) => {
    let description;
    if (move > 0) {
      description = 'Game@ [' + move + ']';
    } else {
      description = 'Game start';
    }
    return (
      <li key={move} className='history-point'>
        <button onClick={() => jumpTo(move)} className='teleporter'>{description}</button>
      </li>
    )
  });

  return (
    <div className='game'>
      <div className='game-board'>
        <Board xIsNext={xIsNext} squares={currentSquares} onPlay={handlePlay} />
      </div>
      <div className='game-info'>
        <ol>{moves}</ol>
      </div>
    </div>
  )
}
function Board({ xIsNext, squares, onPlay }) {

  function handleClick(i) {
    if(squares[i] || calculateWinner(squares)) {
      return;
    }

    const nextSquares = squares.slice();
    if(xIsNext) {
      nextSquares[i] = 'X';
    } else {
      nextSquares[i] = 'O';
    }
    onPlay(nextSquares)
  }

  if (!xIsNext) {
    ai(squares, handleClick)
  }

  const winner = calculateWinner(squares);
  const tie = calculateTie(squares);
  let status;
  if (winner) {
    status = 'Winner: '+ winner;
  } else if (tie) {
    status = 'It\'s a tie!';
  }else {
    status = 'Next Player: '+ (xIsNext ? 'X' : 'O');
  }
  return (
    <>
      <div className='status'>{status}</div>
      <div className="row">
        <Square value={squares[0]} onSquareClick={() => handleClick(0)} />
        <Square value={squares[1]} onSquareClick={() => handleClick(1)} />
        <Square value={squares[2]} onSquareClick={() => handleClick(2)} />
      </div>
      <div className="row">
        <Square value={squares[3]} onSquareClick={() => handleClick(3)} />
        <Square value={squares[4]} onSquareClick={() => handleClick(4)} />
        <Square value={squares[5]} onSquareClick={() => handleClick(5)} />
      </div>
      <div className="row">
        <Square value={squares[6]} onSquareClick={() => handleClick(6)} />
        <Square value={squares[7]} onSquareClick={() => handleClick(7)} />
        <Square value={squares[8]} onSquareClick={() => handleClick(8)} />
      </div>
    </>
  );
}

function calculateTie(squares) {
  for (let i=0; i < squares.length; i++) {
    if (squares[i] === null) {
      return false
    }
  } return true
}

function calculateWinner(squares) {
  const lines = [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [0, 3, 6],
    [1, 4, 7],
    [2, 5, 8],
    [0, 4, 8],
    [2, 4, 6]
  ];
  for (let i = 0; i < lines.length; i++) {
    const [a, b, c] = lines[i];
    // console.log([a, b, c])
    if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
      // console.log(squares[a])
      return squares[a];
    }
  }
  return null;
}

function ai(squares, handleClick) {
  const lines = [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [0, 3, 6],
    [1, 4, 7],
    [2, 5, 8],
    [0, 4, 8],
    [2, 4, 6]
  ];
  for (let i = 0; i < lines.length; i++) {
    const [a, b, c] = lines[i];
    if (squares[a] === 'O' || squares[c] === 'O' || squares[b] === 'O') {
      if(squares[a] && squares[a] === squares[b] && squares[c] === null ){
        console.log('can win', squares[a], squares[b], squares[c])
        handleClick(c)
        return
      } else if (squares[a] && squares[a] === squares[c] && squares[b] === null ) {
        console.log('another one', squares[a], squares[b], squares[c])
        handleClick(b)
        return
      } else if (squares[b] && squares[b] === squares[c] && squares[a] === null) {
        console.log('YET another one', squares[a], squares[b], squares[c])
        handleClick(a)
        return
      }
    } else if (squares[a] === 'X' || squares[c] === 'X' || squares[b] === 'X') {
      if(squares[a] && squares[a] === squares[b] && squares[c] === null ){
        console.log('could Lose 1', a, b, c)
        handleClick(c)
        return
      } else if (squares[a] && squares[a] === squares[c] && squares[b] === null ) {
        console.log('could Lose 2', a, b, c)
        console.log(b)
        handleClick(b)
        return
      } else if (squares[b] && squares[b] === squares[c] && squares[a] === null) {
        console.log('could Lose 3', a, b, c)
        handleClick(a)
        return
      }
    }
  }
  if (squares[4] === null) {
    handleClick(4)
  } else if (squares[0] === null) {
    handleClick(0)
  }else if (squares[2] === null) {
    handleClick(2)
  } else if (squares[6] === null) {
    handleClick(6)
  } else if (squares[8] === null) {
    handleClick(8)
  }
}